export const messages = {
  en: {
    registerProtocol: {

      userProtocol: 'User Service Agreement',
      merchantProtocol: 'Privacy Policy',

      required: 'Required, please fill in the content',
      modifySuccess: 'Modification successful',
      modifyFailed: 'Modification failed'
    }
  },
  zh: {
    registerProtocol: {

      userProtocol: '用户服务协议',
      merchantProtocol: '隐私政策',

      required: '必填，请填写内容',
      modifySuccess: '修改成功',
      modifyFailed: '修改失败'
    }
  }
}
